interface IProps {
  color?: string;
  size?: number;
  onClick?: () => void;
}

const defaultColor = "black";
const defaultSize = "27";

export const IconStarCircle = (props: IProps) => {
  const { color } = props;
  return (
    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.2539 26.199C9.40417 26.1936 6.65815 25.1295 4.54886 23.2132C2.43957 21.297 1.11753 18.6653 0.839506 15.8291C0.561484 12.9929 1.34732 10.1546 3.04434 7.86523C4.74136 5.57583 7.2285 3.99861 10.023 3.43993C11.1578 3.19825 12.3244 3.14323 13.477 3.27697C14.123 3.35897 14.6899 3.56193 14.6129 4.34093C14.5359 5.11993 13.962 5.22694 13.3 5.16894C11.4302 4.96484 9.54173 5.31423 7.86868 6.17358C6.19563 7.03292 4.81168 8.36449 3.88846 10.0032C2.96524 11.6418 2.54335 13.5155 2.6752 15.3917C2.80705 17.2679 3.48683 19.0642 4.63016 20.5576C5.77348 22.0511 7.33004 23.1759 9.10684 23.7928C10.8836 24.4097 12.8025 24.4915 14.6253 24.0279C16.4481 23.5644 18.0947 22.5758 19.3609 21.1849C20.627 19.7941 21.4571 18.0622 21.748 16.204C21.9102 15.221 21.9102 14.218 21.748 13.235C21.6692 13.0184 21.6542 12.7838 21.7045 12.559C21.7548 12.3341 21.8685 12.1283 22.032 11.9659C22.1532 11.8574 22.3015 11.7837 22.4612 11.7527C22.6209 11.7217 22.786 11.7347 22.939 11.79C23.1401 11.8694 23.313 12.0069 23.4356 12.1851C23.5581 12.3632 23.6248 12.5738 23.627 12.79C23.9036 14.441 23.8163 16.1323 23.3715 17.7461C22.9267 19.3598 22.1349 20.857 21.0515 22.133C19.9681 23.4091 18.6192 24.4333 17.099 25.134C15.5788 25.8347 13.9238 26.195 12.2499 26.1899L12.2539 26.199Z"
        fill="black"
      />
      <path
        d="M18.106 12.84C17.251 13.715 16.506 14.514 15.715 15.27C15.5501 15.4017 15.4278 15.5793 15.3634 15.7803C15.299 15.9814 15.2953 16.1969 15.3529 16.4C15.5809 17.468 15.73 18.553 15.94 19.8C14.797 19.209 13.79 18.715 12.813 18.168C12.6618 18.0622 12.4823 18.0042 12.2978 18.0015C12.1132 17.9989 11.9322 18.0517 11.778 18.153C10.938 18.632 10.07 19.064 9.21 19.507C9.073 19.577 8.87496 19.685 8.77396 19.636C8.55596 19.53 8.70504 19.308 8.73404 19.136C8.89004 18.209 9.03403 17.279 9.22403 16.36C9.27782 16.1682 9.27341 15.9646 9.21146 15.7752C9.14951 15.5858 9.03279 15.419 8.87601 15.296C8.20101 14.68 7.55602 14.03 6.91202 13.382C6.77502 13.244 6.49001 13.143 6.59501 12.888C6.67601 12.688 6.92699 12.762 7.10599 12.735C8.00599 12.602 8.91396 12.4651 9.82096 12.3541C10.0201 12.3434 10.212 12.2754 10.3734 12.1583C10.5349 12.0412 10.659 11.88 10.731 11.694C11.187 10.694 11.696 9.71902 12.283 8.53302C12.797 9.57402 13.283 10.446 13.661 11.363C13.7689 11.6762 13.9732 11.9472 14.2447 12.1369C14.5162 12.3266 14.8409 12.4254 15.172 12.419C16.125 12.497 17.065 12.686 18.106 12.84Z"
        fill={color}
      />
      <path
        d="M23.7368 6.286C22.3658 6.286 22.3668 6.28606 22.3648 7.62706C22.386 7.97521 22.3766 8.32449 22.3368 8.67101C22.325 8.79947 22.2879 8.92435 22.2275 9.03832C22.1671 9.15229 22.0846 9.25315 21.9848 9.33495C21.8851 9.41674 21.7701 9.47783 21.6465 9.51476C21.5229 9.55169 21.3931 9.5637 21.2649 9.55004C21.136 9.55875 21.0066 9.54105 20.8847 9.49803C20.7629 9.45502 20.6512 9.38764 20.5564 9.29991C20.4615 9.21219 20.3856 9.106 20.3332 8.9879C20.2809 8.8698 20.2531 8.74221 20.2518 8.61302C20.2139 8.02345 20.2075 7.43228 20.2328 6.84203C20.2448 6.42703 20.0858 6.26202 19.6668 6.28002C19.1308 6.30302 18.5929 6.29002 18.0559 6.28002C17.9137 6.29055 17.7708 6.27182 17.6361 6.22496C17.5014 6.1781 17.3778 6.10409 17.2728 6.00756C17.1678 5.91102 17.0837 5.79398 17.0257 5.66368C16.9678 5.53338 16.9372 5.39259 16.9358 5.24999C16.9328 5.10178 16.9608 4.95457 17.0178 4.81774C17.0748 4.6809 17.1596 4.55743 17.2669 4.45519C17.3743 4.35294 17.5017 4.27417 17.6411 4.22386C17.7805 4.17355 17.929 4.15291 18.0769 4.16307C18.4787 4.12665 18.8829 4.12665 19.2848 4.16307C20.0898 4.27207 20.3309 3.92598 20.2389 3.17198C20.1976 2.74398 20.1976 2.313 20.2389 1.885C20.2603 1.62218 20.3794 1.3769 20.5727 1.19762C20.7661 1.01833 21.0196 0.918119 21.2833 0.916613C21.547 0.915106 21.8016 1.0125 21.997 1.18956C22.1924 1.36662 22.3144 1.61047 22.3388 1.87303C22.3761 2.46267 22.3804 3.05391 22.3518 3.64403C22.3388 4.02803 22.4878 4.17204 22.8678 4.15904C23.4048 4.14004 23.9429 4.14004 24.4789 4.15904C24.6265 4.1445 24.7755 4.16153 24.9161 4.20909C25.0567 4.25665 25.1855 4.33357 25.294 4.4348C25.4026 4.53603 25.4883 4.65932 25.5455 4.79625C25.6027 4.93319 25.6301 5.08065 25.6258 5.22899C25.6198 5.85999 25.1969 6.24206 24.4529 6.27806C24.2209 6.29506 23.9788 6.286 23.7368 6.286Z"
        fill="black"
      />
    </svg>
  );
};

export const IconCoinSub = (props: IProps) => {
  const { size, onClick } = props;
  return (
    <>
      <svg
        width={size || defaultSize}
        height={size || defaultSize}
        viewBox="-2 0 27 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
      >
        <ellipse
          id="Ellipse_135"
          data-name="Ellipse 135"
          cx="9"
          cy="4"
          rx="9"
          ry="4"
          transform="translate(2.5 1.5)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
        />
        <path
          id="Path_11959"
          data-name="Path 11959"
          d="M2.5,6.5v.789c0,2.178,3.883,3.943,8.674,3.943s8.674-1.765,8.674-3.943V6.5"
          transform="translate(0 4.622)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
        />
        <path
          id="Path_11960"
          data-name="Path 11960"
          d="M2.5,9.5v.789c0,2.178,3.883,3.943,8.674,3.943s8.674-1.765,8.674-3.943V9.5"
          transform="translate(0 7.395)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
        />
      </svg>
    </>
  );
};

export const IconStarSub = (props: IProps) => {
  const { color, size, onClick } = props;
  return (
    <>
      <svg
        width={size || defaultSize}
        height={size || defaultSize}
        viewBox="0 0 27 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
      >
        <path
          d="M22.2571 7.456C19.3891 7.256 17.4101 6.24099 16.6031 3.35599C16.4306 2.87126 16.1751 2.42024 15.8481 2.02302C15.5385 1.56364 15.1184 1.18956 14.6262 0.935279C14.1341 0.681001 13.5859 0.554688 13.0321 0.568C12.175 0.590485 11.3506 0.902215 10.693 1.45249C10.0354 2.00277 9.58333 2.75925 9.4101 3.59901C9.13663 4.73726 8.4679 5.74145 7.52308 6.43262C6.57826 7.1238 5.41873 7.45703 4.2511 7.37299C2.5581 7.40299 0.995066 7.89501 0.336066 9.66401C-0.395934 11.63 0.55406 13.113 2.05506 14.244C3.05794 14.8577 3.80708 15.8111 4.16608 16.9307C4.52508 18.0503 4.47006 19.2616 4.01105 20.344C3.45205 21.992 3.49807 23.738 5.17707 24.898C5.84839 25.3727 6.6604 25.6067 7.48139 25.562C8.30238 25.5174 9.0842 25.1967 9.70008 24.652C12.0311 22.875 14.1721 23.052 16.4791 24.652C17.0997 25.1881 17.8814 25.5018 18.7004 25.5437C19.5195 25.5855 20.3291 25.353 21.0011 24.883C21.665 24.3956 22.1393 23.6931 22.3431 22.8951C22.547 22.0971 22.4678 21.2531 22.1191 20.507C21.1281 17.623 22.0681 15.599 24.3701 13.897C24.7731 13.6377 25.1197 13.2997 25.3889 12.9033C25.6582 12.5069 25.8446 12.0602 25.9371 11.59C26.3081 9.287 25.0981 7.656 22.2571 7.456ZM22.3971 12.573C22.172 12.8638 21.909 13.1231 21.6151 13.344C19.1441 14.944 18.6841 17.132 19.6081 19.796C19.7971 20.4297 19.9006 21.0859 19.9161 21.747C19.9861 22.832 19.4261 23.275 18.4161 22.905C17.2194 22.5989 16.0819 22.0961 15.0501 21.417C13.4991 20.117 12.2061 20.44 10.7371 21.395C9.87098 21.9455 8.96087 22.4234 8.01606 22.824C6.84306 23.334 6.17707 22.938 6.19807 21.088C8.21107 17.354 6.46006 14.382 3.06007 11.835C2.18007 11.176 2.40807 10.256 3.60407 9.89002C3.81288 9.81861 4.03145 9.77981 4.25208 9.775C8.15208 9.837 10.5791 8.065 11.8041 4.275C12.3731 2.517 13.4411 2.601 14.3631 4.188C14.4833 4.37292 14.579 4.57259 14.6481 4.78202C15.5781 8.21702 17.8721 9.74699 21.3691 9.72199C22.1301 9.71699 23.1231 9.64699 23.4691 10.58C23.8181 11.541 22.9111 11.996 22.3971 12.578V12.573Z"
          fill="#050505"
        />
        <path
          d="M12.9791 18.458C12.3406 18.4718 11.7088 18.3254 11.1414 18.0321C10.574 17.7388 10.0891 17.308 9.73116 16.779C9.61779 16.6564 9.53003 16.5123 9.47304 16.3553C9.41605 16.1984 9.39096 16.0316 9.39925 15.8648C9.40754 15.698 9.44905 15.5345 9.52132 15.384C9.5936 15.2334 9.69518 15.0988 9.82015 14.988C9.92874 14.8861 10.0572 14.8078 10.1975 14.7579C10.3378 14.708 10.4869 14.6876 10.6354 14.6981C10.7839 14.7085 10.9287 14.7495 11.0606 14.8185C11.1926 14.8875 11.3089 14.983 11.4022 15.099C12.5732 16.289 13.6601 16.228 14.8021 15.055C14.8977 14.9407 15.0172 14.8488 15.1521 14.7857C15.2871 14.7227 15.4342 14.69 15.5832 14.69C15.7321 14.69 15.8792 14.7227 16.0142 14.7857C16.1491 14.8488 16.2686 14.9407 16.3642 15.055C16.5778 15.2637 16.707 15.5437 16.7271 15.8417C16.7472 16.1396 16.6568 16.4345 16.4732 16.67C16.0992 17.2487 15.5793 17.7186 14.9659 18.0325C14.3525 18.3464 13.6673 18.4932 12.9791 18.458Z"
          fill={color || defaultColor}
        />
      </svg>
    </>
  );
};

export const IconStarSmall = (props: IProps) => {
  const { color = "black" } = props;
  return (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.7811 3.42297C10.1957 3.46424 9.61435 3.29818 9.13899 2.95392C8.66364 2.60965 8.32451 2.10912 8.18111 1.53998C8.10183 1.31739 7.98443 1.11029 7.83412 0.927976C7.69207 0.716978 7.49914 0.545184 7.27315 0.428434C7.04716 0.311683 6.79544 0.253741 6.54115 0.259976C6.14757 0.270366 5.76903 0.413543 5.46712 0.666257C5.16521 0.918971 4.95764 1.26637 4.87813 1.65197C4.75253 2.17465 4.44547 2.63574 4.01161 2.95312C3.57776 3.2705 3.04528 3.42355 2.50911 3.38498C2.11637 3.33068 1.71709 3.41695 1.38179 3.62854C1.0465 3.84013 0.79679 4.16341 0.676775 4.54129C0.55676 4.91916 0.574149 5.32729 0.725908 5.69357C0.877668 6.05985 1.15402 6.3607 1.50612 6.54297C1.96667 6.82448 2.31086 7.262 2.47603 7.77588C2.64121 8.28975 2.61642 8.84585 2.40615 9.34298C2.23783 9.69075 2.19519 10.0861 2.28554 10.4617C2.37589 10.8374 2.59364 11.1701 2.90169 11.4033C3.20974 11.6365 3.58905 11.7557 3.97512 11.7407C4.36118 11.7257 4.7301 11.5774 5.01912 11.321C5.45097 10.946 6.0037 10.7395 6.57564 10.7395C7.14758 10.7395 7.70031 10.946 8.13216 11.321C8.41723 11.5672 8.77623 11.7113 9.15242 11.7305C9.52861 11.7497 9.90046 11.6429 10.2091 11.427C10.5143 11.2033 10.7323 10.8806 10.8261 10.514C10.9198 10.1474 10.8834 9.75972 10.7232 9.41699C10.4988 8.87166 10.48 8.26343 10.6701 7.70526C10.8603 7.14709 11.2465 6.67691 11.7572 6.38199C11.9421 6.2629 12.101 6.10774 12.2246 5.92578C12.3481 5.74381 12.4337 5.53877 12.4762 5.32296C12.6412 4.26196 12.0861 3.51397 10.7811 3.42297ZM10.8451 5.77298C10.7418 5.90648 10.6211 6.02554 10.4862 6.12698C9.98528 6.41176 9.61134 6.87629 9.44014 7.42645C9.26895 7.97661 9.31324 8.57126 9.5641 9.08996C9.65147 9.38226 9.69926 9.68499 9.70613 9.98999C9.73813 10.49 9.48115 10.69 9.01515 10.522C8.46547 10.3812 7.94299 10.1501 7.46913 9.83798C7.20078 9.58733 6.84781 9.44707 6.48061 9.44522C6.11341 9.44336 5.75898 9.58004 5.48812 9.82797C5.09026 10.0807 4.67216 10.3002 4.23812 10.484C3.69912 10.718 3.39415 10.536 3.40315 9.68399C4.32715 7.96899 3.52311 6.60396 1.96211 5.43496C1.56211 5.13496 1.66211 4.70999 2.21211 4.54199C2.30876 4.50887 2.41002 4.49098 2.51216 4.48898C3.29798 4.56025 4.08288 4.34355 4.72084 3.87924C5.35881 3.41493 5.80633 2.73463 5.98012 1.96496C6.24112 1.15796 6.73211 1.19599 7.15511 1.92499C7.21038 2.00995 7.25445 2.10169 7.28615 2.19796C7.42529 2.89271 7.81882 3.51046 8.38967 3.93017C8.96051 4.34989 9.66752 4.54133 10.3721 4.46698C10.7211 4.46698 11.1781 4.43299 11.3371 4.86099C11.4961 5.28899 11.0821 5.50598 10.8451 5.77298Z"
        fill="black"
      />
      <path
        d="M6.52 8.47297C6.22668 8.47941 5.93641 8.41222 5.67576 8.27753C5.41512 8.14285 5.19242 7.94495 5.028 7.70197C4.97582 7.64566 4.9354 7.57948 4.90916 7.50733C4.88293 7.43518 4.87141 7.35851 4.87523 7.28184C4.87905 7.20516 4.89816 7.13004 4.93144 7.06086C4.96471 6.99168 5.0115 6.92983 5.06901 6.87897C5.11912 6.83277 5.1781 6.79729 5.24241 6.77473C5.30673 6.75216 5.37498 6.743 5.44298 6.74778C5.51097 6.75256 5.57727 6.77116 5.6378 6.8025C5.69833 6.83383 5.75181 6.87721 5.79497 6.92997C5.88442 7.0545 6.00264 7.15561 6.13951 7.22471C6.27638 7.29381 6.42791 7.32887 6.58122 7.32691C6.73453 7.32495 6.88507 7.28603 7.02012 7.21345C7.15518 7.14086 7.27074 7.03676 7.35698 6.90998C7.40081 6.85748 7.45567 6.81524 7.51762 6.78626C7.57957 6.75728 7.64711 6.74226 7.7155 6.74226C7.78389 6.74226 7.85143 6.75728 7.91337 6.78626C7.97532 6.81524 8.03019 6.85748 8.07402 6.90998C8.17183 7.00583 8.23094 7.1343 8.24016 7.27094C8.24938 7.40758 8.20806 7.54285 8.12401 7.65098C7.95249 7.91689 7.7139 8.13289 7.43229 8.2772C7.15069 8.42151 6.83602 8.48903 6.52 8.47297Z"
        fill={color}
      />
    </svg>
  );
};

export const IconBook = (props: IProps) => {
  const { color = "#FF3E3E" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="51.565"
      height="32.506"
      viewBox="0 0 51.565 32.506"
    >
      <g id="reservation" transform="translate(1.237 1)">
        <path
          id="Path_11947"
          data-name="Path 11947"
          d="M8.084,14l5.084,30.506H52.148L47.064,14H8.084L3,37.727H8.084"
          transform="translate(-3 -14)"
          fill="none"
          stroke="#ff3e3e"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          id="Line_336"
          data-name="Line 336"
          x2="16.558"
          transform="translate(20.236 9.853)"
          fill="none"
          stroke="#ff3e3e"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          id="Line_337"
          data-name="Line 337"
          x2="16.558"
          transform="translate(20.236 18.131)"
          fill="none"
          stroke="#ff3e3e"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export const IconLoyalty = (props: IProps) => {
  const { color = "#FF3E3E" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33.504"
      height="36.82"
      viewBox="0 0 33.504 36.82"
    >
      <g id="tagLoyalty" transform="translate(-5 -2)">
        <path
          id="Path_11945"
          data-name="Path 11945"
          d="M39.256,28.346a4.478,4.478,0,0,0-6.966.71,4.479,4.479,0,0,0-6.966-.71,4.647,4.647,0,0,0,0,6.5l6.965,7.078,6.966-7.078A4.647,4.647,0,0,0,39.256,28.346Z"
          transform="translate(-3.077 -4.103)"
          fill="none"
          stroke="#ff3e3e"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          id="Path_11946"
          data-name="Path 11946"
          d="M20.094,37.82H6V14.607L17.607,3,29.213,14.607v3.316"
          transform="translate(0 0)"
          fill="none"
          stroke="#ff3e3e"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <circle
          id="Ellipse_134"
          data-name="Ellipse 134"
          cx="2.5"
          cy="2.5"
          r="2.5"
          transform="translate(14.991 14.561)"
          fill="none"
          stroke="#ff3e3e"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export const IconProducts = (props: IProps) => {
  const { color = "#FF3E3E" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37.803"
      height="35.652"
      viewBox="0 0 37.803 35.652"
    >
      <g id="box-3d-50" transform="translate(0 -0.882)">
        <line
          id="Line_338"
          data-name="Line 338"
          x2="18.696"
          y2="9.746"
          transform="translate(9.916 5.897)"
          fill="none"
          stroke="#ff3e3e"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          id="Path_11948"
          data-name="Path 11948"
          d="M36.8,10.193,20.095,18.547,1,9"
          transform="translate(0 1.354)"
          fill="none"
          stroke="#ff3e3e"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          id="Line_339"
          data-name="Line 339"
          y2="15.515"
          transform="translate(20.095 19.901)"
          fill="none"
          stroke="#ff3e3e"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          id="Path_11949"
          data-name="Path 11949"
          d="M36.8,11.547V27.062L20.095,35.416,1,25.869V10.354L17.708,2Z"
          fill="none"
          stroke="#ff3e3e"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export const IconViewBooking = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.5" height="15.5" viewBox="0 0 14.5 15.5">
      <g id="document" transform="translate(-0.75 -1.75)">
        <rect
          id="Rectangle_1625"
          data-name="Rectangle 1625"
          width="13"
          height="14"
          rx="1"
          transform="translate(1.5 2.5)"
          fill="none"
          stroke="#212121"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <line
          id="Line_357"
          data-name="Line 357"
          x2="7"
          transform="translate(4.5 6.5)"
          fill="none"
          stroke="#212121"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <line
          id="Line_358"
          data-name="Line 358"
          x2="7"
          transform="translate(4.5 9.5)"
          fill="none"
          stroke="#212121"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <line
          id="Line_359"
          data-name="Line 359"
          x2="3"
          transform="translate(4.5 12.5)"
          fill="none"
          stroke="#212121"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
};

export const IconPoints = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.563"
      height="14.554"
      viewBox="0 0 14.563 14.554"
    >
      <g id="coins" transform="translate(-1.75 -0.766)">
        <ellipse
          id="Ellipse_135"
          data-name="Ellipse 135"
          cx="6.527"
          cy="2.967"
          rx="6.527"
          ry="2.967"
          transform="translate(2.5 1.516)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_11959"
          data-name="Path 11959"
          d="M2.5,6.5v.594c0,1.64,2.924,2.969,6.531,2.969s6.531-1.329,6.531-2.969V6.5"
          transform="translate(0 0.944)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_11960"
          data-name="Path 11960"
          d="M2.5,9.5v.594c0,1.64,2.924,2.969,6.531,2.969s6.531-1.329,6.531-2.969V9.5"
          transform="translate(0 1.507)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
};

export const IconCoupons = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.951"
      height="14.191"
      viewBox="0 0 18.951 14.191"
    >
      <g id="coupon" transform="translate(-0.25 -3.25)">
        <path
          id="Path_11587"
          data-name="Path 11587"
          d="M16.071,10.346a2.337,2.337,0,0,1,2.38-2.38V4H1V7.966a2.38,2.38,0,0,1,0,4.759v3.966H18.451V12.725A2.337,2.337,0,0,1,16.071,10.346Z"
          fill="none"
          stroke="#212121"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <line
          id="Line_228"
          data-name="Line 228"
          x1="7"
          y2="5"
          transform="translate(6 8)"
          fill="none"
          stroke="#212121"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <circle
          id="Ellipse_109"
          data-name="Ellipse 109"
          cx="1"
          cy="1"
          r="1"
          transform="translate(7 7)"
          fill="#212121"
        />
        <circle
          id="Ellipse_110"
          data-name="Ellipse 110"
          cx="1"
          cy="1"
          r="1"
          transform="translate(10 12)"
          fill="#212121"
        />
      </g>
    </svg>
  );
};

export const IconPin = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.173"
      height="21.799"
      viewBox="0 0 17.173 21.799"
    >
      <g id="distance" transform="translate(0)">
        <path
          id="Path_11582"
          data-name="Path 11582"
          d="M29.586,12A8.6,8.6,0,0,0,21,20.586c0,4.592,7.781,12.668,8.112,13.012a.661.661,0,0,0,.948,0c.331-.344,8.112-8.419,8.112-13.012A8.6,8.6,0,0,0,29.586,12Zm0,11.889a3.3,3.3,0,1,1,3.3-3.3A3.3,3.3,0,0,1,29.586,23.889Z"
          transform="translate(-21 -12)"
          fill="#9b9b9b"
        />
      </g>
    </svg>
  );
};
export const WhiteIconPin = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.173"
      height="21.799"
      viewBox="0 0 17.173 21.799"
    >
      <g id="distance" transform="translate(0)">
        <path
          id="Path_11582"
          data-name="Path 11582"
          d="M29.586,12A8.6,8.6,0,0,0,21,20.586c0,4.592,7.781,12.668,8.112,13.012a.661.661,0,0,0,.948,0c.331-.344,8.112-8.419,8.112-13.012A8.6,8.6,0,0,0,29.586,12Zm0,11.889a3.3,3.3,0,1,1,3.3-3.3A3.3,3.3,0,0,1,29.586,23.889Z"
          transform="translate(-21 -12)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};
export const basketCoinsIcon = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 12 12">
      <g transform="translate(-2 -1)">
        <path
          d="M5.5-.5A10.171,10.171,0,0,1,9.6.277c1.228.558,1.9,1.348,1.9,2.223s-.676,1.665-1.9,2.223A10.171,10.171,0,0,1,5.5,5.5a10.171,10.171,0,0,1-4.1-.777C.176,4.165-.5,3.375-.5,2.5S.176.835,1.4.277A10.171,10.171,0,0,1,5.5-.5Zm0,5a9.163,9.163,0,0,0,3.682-.687C10.007,3.438,10.5,2.947,10.5,2.5s-.493-.937-1.318-1.313A9.163,9.163,0,0,0,5.5.5a9.163,9.163,0,0,0-3.682.687C.993,1.563.5,2.053.5,2.5s.493.938,1.318,1.313A9.163,9.163,0,0,0,5.5,4.5Z"
          transform="translate(2.5 1.5)"
          fill="#676767"
        />
        <path
          d="M8,10a10.172,10.172,0,0,1-4.1-.777C2.676,8.665,2,7.876,2,7V6.5a.5.5,0,0,1,1,0V7c0,.447.493.938,1.318,1.313A9.164,9.164,0,0,0,8,9a9.164,9.164,0,0,0,3.682-.687C12.507,7.938,13,7.447,13,7V6.5a.5.5,0,0,1,1,0V7c0,.876-.676,1.665-1.9,2.223A10.172,10.172,0,0,1,8,10Z"
          fill="#676767"
        />
        <path
          d="M8,13a10.172,10.172,0,0,1-4.1-.777C2.676,11.665,2,10.876,2,10V9.5a.5.5,0,0,1,1,0V10c0,.447.493.938,1.318,1.313A9.164,9.164,0,0,0,8,12a9.164,9.164,0,0,0,3.682-.687C12.507,10.938,13,10.447,13,10V9.5a.5.5,0,0,1,1,0V10c0,.876-.676,1.665-1.9,2.223A10.172,10.172,0,0,1,8,13Z"
          fill="#676767"
        />
      </g>
    </svg>
  );
};

export const basketDetailsNote = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9.946" height="9.946" viewBox="0 0 9.946 9.946">
      <g transform="translate(-0.1 -0.1)" opacity="0.8">
        <path
          d="M8.489.1a.4.4,0,0,1,.283.117L10.434,1.88a.4.4,0,0,1,0,.566L6.277,6.6a.4.4,0,0,1-.156.1l-2.494.831a.4.4,0,0,1-.506-.506l.831-2.494a.4.4,0,0,1,.1-.156L8.206.217A.4.4,0,0,1,8.489.1Zm1.1,2.063-1.1-1.1L4.681,4.873,4.132,6.519,5.778,5.97Z"
          transform="translate(-0.506)"
          fill="#9b9b9b"
        />
        <path
          d="M7.983,10.214H1.331A1.233,1.233,0,0,1,.1,8.983V2.331A1.233,1.233,0,0,1,1.331,1.1H2.994a.4.4,0,0,1,0,.8H1.331A.432.432,0,0,0,.9,2.331V8.983a.432.432,0,0,0,.431.431H7.983a.432.432,0,0,0,.431-.431V7.32a.4.4,0,1,1,.8,0V8.983A1.233,1.233,0,0,1,7.983,10.214Z"
          transform="translate(0 -0.169)"
          fill="#9b9b9b"
        />
      </g>
    </svg>
  );
};
export const basketTrashBin = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 13.008 12.984">
      <g transform="translate(-3.404 -5.5)">
        <path
          d="M16.974,25.488H10.227A1.715,1.715,0,0,1,8.5,23.79V15.5h1v8.29a.714.714,0,0,0,.727.7h6.748a.714.714,0,0,0,.727-.7V15.5h1v8.29A1.715,1.715,0,0,1,16.974,25.488Z"
          transform="translate(-3.873 -7.004)"
          fill="#a5a5a5"
        />
        <path d="M12.508.5H-.5v-1H12.508Z" transform="translate(3.904 8.252)" fill="#a5a5a5" />
        <path d="M.5,5h-1V-.5h1Z" transform="translate(9.909 10.503)" fill="#a5a5a5" />
        <path d="M.5,5h-1V-.5h1Z" transform="translate(7.657 10.503)" fill="#a5a5a5" />
        <path d="M.5,5h-1V-.5h1Z" transform="translate(12.16 10.503)" fill="#a5a5a5" />
        <path
          d="M21.694,4.4h-1V2.5H17.5V4.4h-1V1.5h5.194Z"
          transform="translate(-9.476 4)"
          fill="#a5a5a5"
        />
      </g>
    </svg>
  );
};

export const basketStar = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26.619" height="25.7" viewBox="0 0 26.619 25.7">
      <g transform="translate(0.352 0.35)">
        <path
          d="M579.565,337.4c-2.868-.2-4.847-1.215-5.654-4.1a4.439,4.439,0,0,0-.755-1.333,3.3,3.3,0,0,0-2.816-1.455,3.8,3.8,0,0,0-3.622,3.031,4.941,4.941,0,0,1-5.159,3.774c-1.693.03-3.256.522-3.915,2.291-.732,1.966.218,3.449,1.719,4.58a4.906,4.906,0,0,1,1.956,6.1c-.559,1.648-.513,3.394,1.166,4.554a3.648,3.648,0,0,0,4.523-.246c2.331-1.777,4.472-1.6,6.779,0a3.686,3.686,0,0,0,4.522.231,3.559,3.559,0,0,0,1.118-4.376c-.991-2.884-.051-4.908,2.251-6.61a3.56,3.56,0,0,0,1.567-2.307C583.616,339.231,582.406,337.6,579.565,337.4Zm.14,5.117a4.116,4.116,0,0,1-.782.771c-2.471,1.6-2.931,3.788-2.007,6.452a7.435,7.435,0,0,1,.308,1.951c.07,1.085-.49,1.528-1.5,1.158a11.146,11.146,0,0,1-3.366-1.488c-1.551-1.3-2.844-.977-4.313-.022a18.629,18.629,0,0,1-2.721,1.429c-1.173.51-1.839.114-1.818-1.736,2.013-3.734.262-6.706-3.138-9.253-.88-.659-.652-1.579.544-1.945a2.147,2.147,0,0,1,.648-.115c3.9.062,6.327-1.71,7.552-5.5.569-1.758,1.637-1.674,2.559-.087a2.564,2.564,0,0,1,.285.594c.93,3.435,3.224,4.965,6.721,4.94.761-.005,1.754-.075,2.1.858C581.126,341.485,580.219,341.94,579.705,342.522Z"
          transform="translate(-557.393 -330.517)"
          fill="#050505"
        />
        <path
          d="M570.376,330.167a3.629,3.629,0,0,1,3.063,1.6,4.732,4.732,0,0,1,.809,1.444c.693,2.481,2.291,3.631,5.341,3.845a4.526,4.526,0,0,1,3.353,1.48,3.817,3.817,0,0,1,.648,3.058,3.925,3.925,0,0,1-1.7,2.533c-2.351,1.738-3.007,3.655-2.128,6.215.691,2.013.249,3.709-1.246,4.775a3.743,3.743,0,0,1-2.2.741,4.812,4.812,0,0,1-2.726-.969,5.771,5.771,0,0,0-3.271-1.206,5.071,5.071,0,0,0-3.1,1.194,4.468,4.468,0,0,1-2.688.992,3.908,3.908,0,0,1-2.246-.737c-1.579-1.09-2.028-2.8-1.3-4.954.807-2.381.241-4.14-1.835-5.7-1.912-1.441-2.53-3.117-1.836-4.982.617-1.655,2-2.479,4.237-2.519a5.274,5.274,0,0,0,3.064-.868,4.95,4.95,0,0,0,1.767-2.662,4.135,4.135,0,0,1,3.946-3.275Zm5.937,24.989a3.057,3.057,0,0,0,1.793-.611,3.242,3.242,0,0,0,.99-3.977c-.981-2.856-.227-5.082,2.374-7a3.2,3.2,0,0,0,1.429-2.081,3.1,3.1,0,0,0-.505-2.512,3.862,3.862,0,0,0-2.854-1.217c-3.35-.235-5.19-1.579-5.966-4.355a4.159,4.159,0,0,0-.7-1.221,2.962,2.962,0,0,0-2.5-1.311h-.03c-1.614.045-2.722.983-3.294,2.787a5.619,5.619,0,0,1-2.027,3.019,5.943,5.943,0,0,1-3.459,1c-1.94.035-3.082.69-3.594,2.063-.581,1.562-.057,2.929,1.6,4.178,2.324,1.751,2.984,3.813,2.077,6.488-.627,1.849-.279,3.247,1.034,4.153a3.222,3.222,0,0,0,1.848.613,3.779,3.779,0,0,0,2.264-.849,5.739,5.739,0,0,1,3.52-1.337,6.436,6.436,0,0,1,3.67,1.331A4.135,4.135,0,0,0,576.313,355.156Zm-6.059-22.576c.595,0,1.188.479,1.714,1.385l.019.033a2.706,2.706,0,0,1,.3.645c.86,3.175,2.946,4.707,6.38,4.682.117,0,.239,0,.364,0a1.943,1.943,0,0,1,2.067,1.089,1.743,1.743,0,0,1-.766,1.984,5.021,5.021,0,0,0-.366.358l-.106.122a3.644,3.644,0,0,1-.747.711,4.671,4.671,0,0,0-2.13,2.629,5.615,5.615,0,0,0,.263,3.415,7.687,7.687,0,0,1,.327,2.043,1.692,1.692,0,0,1-.356,1.31,1.149,1.149,0,0,1-.864.348,2.225,2.225,0,0,1-.754-.15c-.247-.09-.507-.177-.759-.261a8.206,8.206,0,0,1-2.711-1.287,2.852,2.852,0,0,0-1.827-.777,3.855,3.855,0,0,0-2.072.78,18.868,18.868,0,0,1-2.773,1.457,2.412,2.412,0,0,1-.951.234,1.14,1.14,0,0,1-.842-.336,2.711,2.711,0,0,1-.515-1.958v-.086l.041-.076a5.39,5.39,0,0,0,.444-4.776,9.915,9.915,0,0,0-3.484-4.031,1.413,1.413,0,0,1-.657-1.354A1.69,1.69,0,0,1,560.8,339.5a2.544,2.544,0,0,1,.73-.131h.026l.191,0c3.631,0,5.862-1.67,7.022-5.256C569.185,332.847,569.806,332.58,570.254,332.58Zm8.334,7.445a7.452,7.452,0,0,1-4.472-1.259,6.918,6.918,0,0,1-2.5-3.94,2.121,2.121,0,0,0-.23-.476l-.02-.034c-.377-.649-.792-1.037-1.109-1.037-.3,0-.6.385-.815,1.055-1.25,3.863-3.765,5.74-7.688,5.74l-.2,0h-.014a1.908,1.908,0,0,0-.526.1c-.469.143-.776.389-.823.657-.038.219.1.458.387.673,4.027,3.016,5.1,6.164,3.278,9.621,0,.872.169,1.229.313,1.374a.445.445,0,0,0,.345.128,1.776,1.776,0,0,0,.672-.175,18.186,18.186,0,0,0,2.67-1.4,4.487,4.487,0,0,1,2.453-.893,3.515,3.515,0,0,1,2.275.94,7.708,7.708,0,0,0,2.485,1.161c.256.086.522.174.777.268a1.54,1.54,0,0,0,.514.107.458.458,0,0,0,.354-.127,1.088,1.088,0,0,0,.168-.786,7.127,7.127,0,0,0-.29-1.859,6.28,6.28,0,0,1-.275-3.837A5.407,5.407,0,0,1,578.734,343a3.086,3.086,0,0,0,.6-.582l.11-.126a5.623,5.623,0,0,1,.418-.411c.494-.453.765-.734.583-1.224-.2-.53-.666-.633-1.411-.633-.123,0-.243,0-.359,0Z"
          transform="translate(-557.393 -330.517)"
          fill="#fff"
        />
        <path
          d="M582.084,366.285a3.822,3.822,0,0,1-3.248-1.679,1.255,1.255,0,0,1,.089-1.791,1.081,1.081,0,0,1,1.582.111c1.171,1.19,2.258,1.129,3.4-.044a1.018,1.018,0,0,1,1.562,0,1.214,1.214,0,0,1,.109,1.615A3.922,3.922,0,0,1,582.084,366.285Z"
          transform="translate(-569.19 -348.4)"
        />
        <path
          d="M582.088,366.635h-.011a4.161,4.161,0,0,1-3.531-1.834,1.586,1.586,0,0,1,.149-2.25,1.443,1.443,0,0,1,.951-.381,1.578,1.578,0,0,1,1.11.51,2.074,2.074,0,0,0,1.424.76,2.157,2.157,0,0,0,1.477-.8,1.425,1.425,0,0,1,1.023-.47,1.48,1.48,0,0,1,1.034.466,1.553,1.553,0,0,1,.163,2.047,4.228,4.228,0,0,1-3.778,1.954Zm-2.442-3.765a.746.746,0,0,0-.491.208c-.144.126-.583.509-.029,1.332a3.442,3.442,0,0,0,2.953,1.524,3.54,3.54,0,0,0,3.2-1.619c.431-.7.065-1.064-.056-1.182a.821.821,0,0,0-.544-.265.763.763,0,0,0-.522.259,2.8,2.8,0,0,1-1.978,1.014,2.719,2.719,0,0,1-1.923-.969A.9.9,0,0,0,579.646,362.87Z"
          transform="translate(-569.19 -348.4)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};
export const basketCoupon = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.5" height="17.5" viewBox="0 0 23.5 17.5">
      <g transform="translate(-0.25 -3.25)">
        <path
          d="M.25,3.25h23.5v6.5H23a2.25,2.25,0,0,0,0,4.5h.75v6.5H.25v-6.5H1a2.25,2.25,0,0,0,0-4.5H.25Zm22,1.5H1.75V8.321A3.683,3.683,0,0,1,3.668,9.332a3.83,3.83,0,0,1,0,5.336A3.683,3.683,0,0,1,1.75,15.679V19.25h20.5V15.679a3.683,3.683,0,0,1-1.918-1.011,3.83,3.83,0,0,1,0-5.336A3.683,3.683,0,0,1,22.25,8.321Z"
          fill="#212121"
        />
        <path d="M0,7.061-1.061,6,6-1.061,7.061,0Z" transform="translate(9 9)" fill="#212121" />
        <circle cx="1.5" cy="1.5" r="1.5" transform="translate(8 7)" fill="#212121" />
        <circle cx="1.5" cy="1.5" r="1.5" transform="translate(13 14)" fill="#212121" />
      </g>
    </svg>
  );
};
export const basketCard = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.464"
      height="21.867"
      viewBox="0 0 20.464 21.867"
    >
      <g transform="translate(2716.826 -1142.333)">
        <rect
          width="17.889"
          height="13"
          rx="3"
          transform="matrix(0.309, -0.951, 0.951, 0.309, -2714.254, 1159.461)"
          fill="#fff"
        />
        <path
          d="M3,1.5A1.5,1.5,0,0,0,1.5,3v7A1.5,1.5,0,0,0,3,11.5H14.889a1.5,1.5,0,0,0,1.5-1.5V3a1.5,1.5,0,0,0-1.5-1.5H3M3,0H14.889a3,3,0,0,1,3,3v7a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z"
          transform="matrix(0.309, -0.951, 0.951, 0.309, -2714.254, 1159.461)"
        />
        <rect
          width="21.867"
          height="16"
          rx="3"
          transform="translate(-2716.826 1164.199) rotate(-90)"
          fill="#fff"
        />
        <path
          d="M3,1.5A1.5,1.5,0,0,0,1.5,3V13A1.5,1.5,0,0,0,3,14.5H18.867a1.5,1.5,0,0,0,1.5-1.5V3a1.5,1.5,0,0,0-1.5-1.5H3M3,0H18.867a3,3,0,0,1,3,3V13a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z"
          transform="translate(-2716.826 1164.199) rotate(-90)"
        />
        <path
          d="M5,.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H5A.75.75,0,0,1,5.75,0,.75.75,0,0,1,5,.75Z"
          transform="translate(-2711.5 1146.5)"
        />
      </g>
    </svg>
  );
};
export const checkoutArrow = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8.826" height="4.276" viewBox="0 0 8.826 4.276">
      <g transform="translate(162.826 -267.632) rotate(90)">
        <g transform="translate(268.132 154.5)">
          <path d="M2.893,4.234-.383.321.383-.321,3.66,3.592Z" transform="translate(0 0)" />
          <path
            d="M3.276,4.413a.5.5,0,0,1-.384-.179L-.383.321a.5.5,0,0,1,.062-.7.5.5,0,0,1,.7.062L3.66,3.592a.5.5,0,0,1-.383.821Z"
            transform="translate(0 0)"
          />
        </g>
        <g transform="translate(268.132 158.413)">
          <path d="M.383,4.234l-.767-.642L2.893-.321,3.66.321Z" transform="translate(0 0)" />
          <path
            d="M0,4.413A.5.5,0,0,1-.321,4.3a.5.5,0,0,1-.062-.7L2.893-.321a.5.5,0,0,1,.7-.062.5.5,0,0,1,.062.7L.383,4.234A.5.5,0,0,1,0,4.413Z"
            transform="translate(0 0)"
          />
        </g>
      </g>
    </svg>
  );
};
export const checkoutClock = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
      <g transform="translate(-1 -1.445)">
        <path
          d="M6.5-.5a7,7,0,1,1-7,7A7.008,7.008,0,0,1,6.5-.5Zm0,13a6,6,0,1,0-6-6A6.007,6.007,0,0,0,6.5,12.5Z"
          transform="translate(1.5 1.945)"
          fill="#9b9b9b"
        />
        <path
          d="M12.218,8.718H8.5a.5.5,0,0,1-.5-.5V4.5a.5.5,0,0,1,1,0V7.718h3.218a.5.5,0,0,1,0,1Z"
          transform="translate(-0.493 0.046)"
          fill="#9b9b9b"
        />
      </g>
    </svg>
  );
};
export const checkoutShop = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.69"
      height="14.703"
      viewBox="0 0 15.69 14.703"
    >
      <g transform="translate(-1.537 -3.5)">
        <path
          d="M21.267,42.373H9.5V35.5h1v5.873h9.767V35.5h1Z"
          transform="translate(-6.002 -24.17)"
          fill="#9b9b9b"
        />
        <path
          d="M11.092,10.862h0a2.729,2.729,0,0,1-1.707-.624,2.729,2.729,0,0,1-1.707.624H7.668a2.674,2.674,0,0,1-1.718-.624,2.784,2.784,0,0,1-1.7.624H4.243a2.7,2.7,0,0,1-2.686-2.4l-.02-.181L4.709,3.5h9.346l3.172,4.78-.02.181a2.7,2.7,0,0,1-2.686,2.4h-.008a2.744,2.744,0,0,1-1.7-.622,2.674,2.674,0,0,1-1.716.622ZM12.8,8.731l.393.485a1.747,1.747,0,0,0,1.329.647,1.7,1.7,0,0,0,1.661-1.344L13.518,4.5H5.245L2.578,8.518A1.7,1.7,0,0,0,4.237,9.862a1.785,1.785,0,0,0,1.333-.65l.394-.478.384.486a1.681,1.681,0,0,0,1.318.642,1.732,1.732,0,0,0,1.326-.646l.389-.482.389.482a1.733,1.733,0,0,0,1.326.646,1.681,1.681,0,0,0,1.318-.642Z"
          fill="#9b9b9b"
        />
        <path
          d="M29.436,47.915h-1V44.5H26.5v3.415h-1V43.5h3.936Z"
          transform="translate(-18.087 -30.212)"
          fill="#9b9b9b"
        />
      </g>
    </svg>
  );
};
export const checkoutDistance = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.956"
      height="16.177"
      viewBox="0 0 12.956 16.177"
    >
      <g transform="translate(0.5 0.5)">
        <path
          d="M26.977,11.5h0a6.5,6.5,0,0,1,6.477,6.477c0,1.439-.95,3.431-2.824,5.921a41.043,41.043,0,0,1-2.961,3.483l0,0a.96.96,0,0,1-1.378,0l0,0A41.038,41.038,0,0,1,23.324,23.9c-1.874-2.49-2.824-4.482-2.824-5.921A6.5,6.5,0,0,1,26.977,11.5Zm0,15.159c2.05-2.137,5.478-6.336,5.478-8.681a5.478,5.478,0,1,0-10.956,0C21.5,20.324,24.93,24.523,26.978,26.659Zm0-11.48a2.8,2.8,0,1,1-2.8,2.8A2.8,2.8,0,0,1,26.978,15.179Zm0,4.6a1.8,1.8,0,1,0-1.8-1.8A1.8,1.8,0,0,0,26.978,19.777Z"
          transform="translate(-21 -12)"
          fill="#9b9b9b"
        />
      </g>
    </svg>
  );
};
export const checkoutCheck = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9.322" height="6.991" viewBox="0 0 9.322 6.991">
      <g transform="translate(0 -1)">
        <path
          d="M8,1.228,3.107,6.116,1.326,4.335a.777.777,0,1,0-1.1,1.1l2.33,2.33a.777.777,0,0,0,1.1,0L9.094,2.326A.777.777,0,1,0,8,1.228Z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};
export const checkoutCopy = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16">
      <g transform="translate(-2)">
        <path
          d="M0-.5H9a.5.5,0,0,1,.5.5V11a.5.5,0,0,1-.5.5H0A.5.5,0,0,1-.5,11V0A.5.5,0,0,1,0-.5ZM8.5.5H.5v10h8Z"
          transform="translate(2.5 4.5)"
          fill="rgba(100,100,100,0.72)"
        />
        <path
          d="M13.5,14a.5.5,0,0,1-.5-.5V3H4.5a.5.5,0,0,1,0-1h9a.5.5,0,0,1,.5.5v11A.5.5,0,0,1,13.5,14Z"
          fill="rgba(100,100,100,0.72)"
        />
        <path
          d="M15.5,11a.5.5,0,0,1-.5-.5V1H7.5a.5.5,0,0,1,0-1h8a.5.5,0,0,1,.5.5v10A.5.5,0,0,1,15.5,11Z"
          fill="rgba(100,100,100,0.72)"
        />
      </g>
    </svg>
  );
};
export const checkoutPayment = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.978"
      height="12.978"
      viewBox="0 0 12.978 12.978"
    >
      <path
        d="M1.5-.5a2,2,0,1,1-2,2A2,2,0,0,1,1.5-.5Zm0,3a1,1,0,1,0-1-1A1,1,0,0,0,1.5,2.5Z"
        transform="translate(7.478 6.5)"
        fill="#a5a5a5"
      />
      <path
        d="M12.478,12.978H2.1a2.1,2.1,0,0,1-2.1-2.1V2.1A2.1,2.1,0,0,1,2.1,0H9.284a.5.5,0,0,1,.5.5V2.1a.5.5,0,0,1-1,0V1H2.1a1.1,1.1,0,1,0,0,2.194H12.478a.5.5,0,0,1,.5.5v8.784A.5.5,0,0,1,12.478,12.978ZM1,3.884v7a1.1,1.1,0,0,0,1.1,1.1h9.881V4.194H2.1A2.085,2.085,0,0,1,1,3.884Z"
        transform="translate(0 0)"
        fill="#a5a5a5"
      />
    </svg>
  );
};
export const cancelCloseIcon = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5">
      <g transform="translate(-355.25 -210.25)">
        <path
          d="M18,18.75a.748.748,0,0,1-.53-.22l-18-18A.75.75,0,0,1-.53-.53.75.75,0,0,1,.53-.53l18,18A.75.75,0,0,1,18,18.75Z"
          transform="translate(356 211)"
          fill="#a1a1a1"
        />
        <path
          d="M0,18.75a.748.748,0,0,1-.53-.22.75.75,0,0,1,0-1.061l18-18a.75.75,0,0,1,1.061,0,.75.75,0,0,1,0,1.061l-18,18A.748.748,0,0,1,0,18.75Z"
          transform="translate(356 211)"
          fill="#a1a1a1"
        />
      </g>
    </svg>
  );
};
export const cancelGreenDoneIcon = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="125.83"
      height="125.83"
      viewBox="0 0 125.83 125.83"
    >
      <g transform="translate(-1 -1)">
        <path
          d="M25.735,126.83a2.735,2.735,0,0,1,0-5.471,57.444,57.444,0,0,0,0-114.888,2.735,2.735,0,1,1,0-5.471,62.915,62.915,0,0,1,0,125.83Z"
          transform="translate(38.18 0)"
          fill="#9ee09e"
        />
        <path
          d="M3.984,36.634A2.735,2.735,0,0,1,1.249,34.12C1.134,32.566,1,30.752,1,28.9s.134-3.66.26-5.214a2.736,2.736,0,0,1,5.454.443C6.6,25.58,6.471,27.262,6.471,28.9s.126,3.326.243,4.773a2.735,2.735,0,0,1-2.506,2.949C4.135,36.631,4.058,36.634,3.984,36.634Z"
          transform="translate(0 35.012)"
          fill="#c5edc5"
        />
        <path
          d="M14.219,12.638A2.735,2.735,0,0,1,12.78,7.577a62.763,62.763,0,0,1,9.3-4.757,2.737,2.737,0,0,1,2.06,5.072,57.036,57.036,0,0,0-8.48,4.338,2.719,2.719,0,0,1-1.442.408Z"
          transform="translate(18.197 2.808)"
          fill="#c5edc5"
        />
        <path
          d="M6.11,23.955a2.67,2.67,0,0,1-1.234-.3,2.735,2.735,0,0,1-1.2-3.674A63.309,63.309,0,0,1,9.144,11.1a2.739,2.739,0,0,1,4.415,3.242,57.769,57.769,0,0,0-5.006,8.116A2.735,2.735,0,0,1,6.11,23.955Z"
          transform="translate(4.127 15.585)"
          fill="#c5edc5"
        />
        <path
          d="M11.305,46.856a2.735,2.735,0,0,1-2.213-1.122,63.785,63.785,0,0,1-5.454-8.923A2.737,2.737,0,1,1,8.526,34.35,57.716,57.716,0,0,0,13.513,42.5a2.735,2.735,0,0,1-2.208,4.349Z"
          transform="translate(4.069 55.262)"
          fill="#c5edc5"
        />
        <path
          d="M23.1,51.746a2.708,2.708,0,0,1-1.034-.2,62.99,62.99,0,0,1-9.322-4.787,2.735,2.735,0,1,1,2.881-4.651,57.691,57.691,0,0,0,8.51,4.377A2.735,2.735,0,0,1,23.1,51.752Z"
          transform="translate(18.129 70.625)"
          fill="#c5edc5"
        />
        <path
          d="M34.4,68.022,11.387,45.006a2.735,2.735,0,0,1,0-3.868l3.868-3.868a2.735,2.735,0,0,1,3.868,0L36.337,54.485l39.1-39.1a2.735,2.735,0,0,1,3.868,0l3.868,3.868a2.735,2.735,0,0,1,0,3.868l-44.9,44.9A2.735,2.735,0,0,1,34.4,68.022Z"
          transform="translate(16.636 23.578)"
          fill="#49c549"
        />
      </g>
    </svg>
  );
};
export const WalkinTurnE = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10">
      <g transform="translate(0 -1)">
        <path
          d="M1,11a1,1,0,0,0,1-1V6H7V8.5a.5.5,0,0,0,.829.376l4-3.5a.5.5,0,0,0,0-.752l-4-3.5A.5.5,0,0,0,7,1.5V4H1A1,1,0,0,0,0,5v5A1,1,0,0,0,1,11Z"
          fill="#212121"
        />
      </g>
    </svg>
  );
};
export const ChatGreenIcon = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="68"
      height="68"
      viewBox="0 0 68 68"
    >
      <defs>
        <clipPath id="a">
          <circle cx="34" cy="34" r="34" transform="translate(-6979 -4645)" fill="#fff" />
        </clipPath>
        <pattern id="b" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 635 633">
          <image
            width="635"
            height="633"
            xlinkHref="data:image/png;base64,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"
          />
        </pattern>
      </defs>
      <g transform="translate(6979 4645)" clip-path="url(#a)">
        <rect width="73" height="72" transform="translate(-6982 -4646)" fill="url(#b)" />
      </g>
    </svg>
  );
};

export const IconCall = (props: IProps) => {
  return (
    <svg
      id="phone"
      xmlns="http://www.w3.org/2000/svg"
      width="18.704"
      height="18.574"
      viewBox="0 0 18.704 18.574"
    >
      <path
        id="Path_11577"
        data-name="Path 11577"
        d="M14.488,13.472l-1.524,1.892A16.025,16.025,0,0,1,7.247,9.689L9.152,8.175a1.279,1.279,0,0,0,.374-1.526L7.789,2.766a1.3,1.3,0,0,0-1.51-.723l-3.306.851a1.293,1.293,0,0,0-.961,1.429,19.148,19.148,0,0,0,16.354,16.24,1.3,1.3,0,0,0,1.439-.954l.857-3.284a1.285,1.285,0,0,0-.728-1.5L16.024,13.1a1.3,1.3,0,0,0-1.536.369Z"
        transform="translate(-2 -2.001)"
        fill="#9b9b9b"
      />
    </svg>
  );
};

export const arrow = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 18.696">
      <g id="priorityLow" transform="translate(-6.586 19.281) rotate(-90)">
        <path
          id="Path_11576"
          data-name="Path 11576"
          d="M2,8l7.934,7.934L17.867,8"
          transform="translate(0 0)"
          fill="none"
          stroke={props?.color || "#000"}
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export const PromotionCode = (props: IProps) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5375_2751)">
        <path
          d="M23.794 0.205975C23.5194 -0.0686178 23.0742 -0.0686178 22.7996 0.205975L20.7516 2.25394C20.6257 2.19394 20.4929 2.14561 20.3542 2.11097L13.9899 0.538647C13.2753 0.360006 12.5076 0.572584 11.9867 1.09351L0.616876 12.4446C-0.205544 13.2671 -0.205544 14.6054 0.616876 15.4279L8.57216 23.3831C9.39462 24.2056 10.7329 24.2056 11.5554 23.3831L22.9066 12.0132C23.4275 11.4923 23.6401 10.7247 23.4614 10.01L21.8891 3.6458C21.8544 3.50714 21.8061 3.37425 21.7461 3.24834L23.7941 1.20038C24.0686 0.925787 24.0686 0.480569 23.794 0.205975ZM22.097 10.3512C22.1566 10.5894 22.0857 10.8452 21.9121 11.0189L10.5609 22.3887C10.2867 22.6629 9.84064 22.6629 9.56647 22.3887L1.61123 14.4334C1.33706 14.1593 1.33706 13.7132 1.61123 13.439L12.9811 2.08791C13.1141 1.95493 13.2953 1.88222 13.4799 1.88222C13.5364 1.88222 13.5931 1.88902 13.6489 1.90294L19.6268 3.3787L17.9335 5.07206C17.1495 4.69865 16.1811 4.83562 15.533 5.48372C14.7105 6.30623 14.7105 7.64446 15.533 8.46698C15.9442 8.87821 16.4844 9.08385 17.0246 9.08385C17.5647 9.08385 18.105 8.87826 18.5162 8.46698C19.1644 7.81879 19.3013 6.85045 18.9278 6.06646L20.6212 4.37311L22.097 10.3512ZM17.5218 7.47262C17.2477 7.74674 16.8016 7.74679 16.5274 7.47262C16.2533 7.19849 16.2533 6.75234 16.5274 6.47821C16.6645 6.3411 16.8445 6.27262 17.0246 6.27262C17.2046 6.27262 17.3847 6.34115 17.5217 6.47817L17.5217 6.47821L17.5218 6.47826C17.796 6.75238 17.7959 7.19849 17.5218 7.47262Z"
          fill="black"
        />
        <path
          d="M11.5553 8.46701C10.7329 7.64454 9.39459 7.64454 8.57208 8.46701C7.74966 9.28948 7.74966 10.6278 8.57208 11.4503C9.39454 12.2727 10.7329 12.2727 11.5553 11.4503C12.3779 10.6278 12.3779 9.28952 11.5553 8.46701ZM10.561 10.4558C10.2868 10.73 9.8407 10.73 9.56657 10.4558C9.29245 10.1816 9.29236 9.73554 9.56653 9.46141C9.8407 9.18729 10.2868 9.18724 10.561 9.46141C10.8351 9.73554 10.8351 10.1816 10.561 10.4558Z"
          fill="black"
        />
        <path
          d="M12.5497 15.4278C11.7254 14.6034 10.3911 14.6034 9.56653 15.4278C8.74402 16.2504 8.74402 17.5886 9.56653 18.4111C10.391 19.2355 11.7253 19.2356 12.5497 18.4111C13.3723 17.5886 13.3723 16.2504 12.5497 15.4278ZM11.5553 17.4167C11.2806 17.6915 10.8357 17.6915 10.5609 17.4167C10.2868 17.1426 10.2868 16.6964 10.5609 16.4223C10.8357 16.1475 11.2806 16.1475 11.5553 16.4223C11.8295 16.6964 11.8295 17.1425 11.5553 17.4167Z"
          fill="black"
        />
        <path
          d="M15.7346 12.8642C15.6917 12.4782 15.344 12.2001 14.9581 12.243L6.00847 13.2374C5.6225 13.2803 5.34435 13.6279 5.38724 14.0139C5.42722 14.3735 5.73163 14.6395 6.08525 14.6395C6.11117 14.6395 6.13742 14.6381 6.16377 14.6351L15.1135 13.6407C15.4994 13.5978 15.7776 13.2502 15.7346 12.8642Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_5375_2751">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const redArrowButton = (props: IProps) => {
  return (
    <svg
      id="Component_51_8"
      data-name="Component 51 – 8"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="Group_3286" data-name="Group 3286" transform="translate(0.069)">
        <g
          id="Ellipse"
          transform="translate(-0.069)"
          fill="#f22f46"
          stroke="#f22f46"
          strokeWidth="1"
        >
          <circle cx="12" cy="12" r="12" stroke="none" />
          <circle cx="12" cy="12" r="11.5" fill="none" />
        </g>
      </g>
      <g id="Component_55_12" data-name="Component 55 – 12" transform="translate(11 6.71)">
        <g id="Group_94" data-name="Group 94">
          <line
            id="Line_38"
            data-name="Line 38"
            x2="4.429"
            y2="5.29"
            transform="translate(0 0)"
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="1.3"
          />
          <line
            id="Line_39"
            data-name="Line 39"
            x2="4.429"
            y2="5.29"
            transform="translate(0 0)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.3"
          />
        </g>
        <g id="Group_95" data-name="Group 95" transform="translate(0 5.29)">
          <line
            id="Line_40"
            data-name="Line 40"
            y1="5.29"
            x2="4.429"
            transform="translate(0 0)"
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="1.3"
          />
          <line
            id="Line_41"
            data-name="Line 41"
            y1="5.29"
            x2="4.429"
            transform="translate(0 0)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.3"
          />
        </g>
      </g>
    </svg>
  );
};

export const allServices = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26.5" height="32.5" viewBox="0 0 26.5 32.5">
      <g id="hair-towel" transform="translate(-2.75 0.25)">
        <path
          id="Path_11918"
          data-name="Path 11918"
          d="M6.438,18.632C6.467,25.041,10.736,31,16,31c5.2,0,9.414-5.8,9.552-12.118"
          fill="none"
          stroke="#f22f46"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="2.5"
        />
        <path
          id="Path_11919"
          data-name="Path 11919"
          d="M25.385,8.265S25,1,16,1C9.373,1,4,5.925,4,12a10.4,10.4,0,0,0,2.667,6.915C16,16,12,7,21.5,7A6.5,6.5,0,0,1,28,13.5a8.2,8.2,0,0,1-2.432,5.415A12.973,12.973,0,0,0,14,11.909"
          fill="none"
          stroke="#f22f46"
          strokeMiterlimit="10"
          strokeWidth="2.5"
        />
      </g>
    </svg>
  );
};

export const IconHairCut = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.285"
      height="24.234"
      viewBox="0 0 24.285 24.234"
    >
      <g id="hairdresser" transform="translate(0.001 0)">
        <path
          id="Path_11570"
          data-name="Path 11570"
          d="M10.885,9.248,14.8,2.258A1.518,1.518,0,1,0,12.152.777L9.146,6.143Z"
          transform="translate(4.735)"
          fill="#f22f46"
        />
        <path
          id="Path_11571"
          data-name="Path 11571"
          d="M13.011,10.224,11.272,7.117,8.716,11.679a4.507,4.507,0,0,0-7.35.724L.608,13.717a4.56,4.56,0,0,0,1.669,6.222h0A4.553,4.553,0,0,0,8.5,18.27ZM3.795,17.306a1.518,1.518,0,0,1-.555-2.073L4,13.92a1.518,1.518,0,0,1,2.78.364,1.5,1.5,0,0,1-.152,1.152l-.759,1.314A1.518,1.518,0,0,1,3.795,17.306Z"
          transform="translate(0 3.684)"
          fill="#f22f46"
        />
        <path
          id="Path_11572"
          data-name="Path 11572"
          d="M22.122,17.4l-.759-1.316a4.51,4.51,0,0,0-7.347-.721L5.843.777a1.518,1.518,0,1,0-2.65,1.481L14.23,21.952a4.553,4.553,0,0,0,6.222,1.669h0A4.56,4.56,0,0,0,22.122,17.4ZM18.935,20.99a1.518,1.518,0,0,1-2.073-.555L16.1,19.121a1.518,1.518,0,1,1,2.63-1.518l.759,1.314a1.518,1.518,0,0,1-.557,2.073Z"
          transform="translate(1.553 0)"
          fill="#f22f46"
        />
      </g>
    </svg>
  );
};

export const IconManicure = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="34.222" viewBox="0 0 19.5 34.222">
      <g id="nail-polish-2" transform="translate(-14.673 -0.75)">
        <path
          id="Path_11920"
          data-name="Path 11920"
          d="M15.923,43.8,15.964,29H32.882l.041,14.8a2.644,2.644,0,0,1-2.644,2.651H18.566A2.644,2.644,0,0,1,15.923,43.8Z"
          transform="translate(0 -12.725)"
          fill="none"
          stroke="#f22f46"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="2.5"
        />
        <path
          id="Path_11921"
          data-name="Path 11921"
          d="M25,13.631V2h7.4V13.631"
          transform="translate(-4.278)"
          fill="none"
          stroke="#f22f46"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="2.5"
        />
        <path
          id="Path_11922"
          data-name="Path 11922"
          d="M25,38h7.4l-.529,7.931H25.529Z"
          transform="translate(-4.278 -16.967)"
          fill="none"
          stroke="#f22f46"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="2.5"
        />
      </g>
    </svg>
  );
};

export const IconEyebrows = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40.938"
      height="17.725"
      viewBox="0 0 40.938 17.725"
    >
      <g id="eyelash" transform="translate(-0.999 -14)">
        <path
          id="Path_11923"
          data-name="Path 11923"
          d="M41.869,27.883a1.335,1.335,0,0,0-1.686-.851,16.945,16.945,0,0,1-5.733.836,11.535,11.535,0,0,0,5.655-6.456.89.89,0,0,0-1.678-.589,9.765,9.765,0,0,1-7.606,6.384,1.79,1.79,0,0,1-.8-.053,16.474,16.474,0,0,1-2.444-.936,11.261,11.261,0,0,0,7.236-9.458.89.89,0,0,0-1.771-.178,9.49,9.49,0,0,1-7.1,8.293,1.735,1.735,0,0,1-1.192-.156,18.977,18.977,0,0,0-1.943-.84A10.65,10.65,0,0,0,27.7,14.89a.89.89,0,1,0-1.78,0,8.877,8.877,0,0,1-5.072,8.052,1.721,1.721,0,0,1-1.068.11,19.24,19.24,0,0,0-3.261-.351A11.1,11.1,0,0,0,19.7,14.89a.89.89,0,0,0-1.78,0,9.321,9.321,0,0,1-4.183,7.8,1.787,1.787,0,0,1-.7.26,18.936,18.936,0,0,0-1.869.392,10.338,10.338,0,0,0,1.407-5.186,10.264,10.264,0,0,0-.128-1.628.89.89,0,1,0-1.757.279,8.649,8.649,0,0,1,.105,1.348,8.564,8.564,0,0,1-2.6,6.133,1.77,1.77,0,0,1-.471.32c-.483.233-.957.489-1.424.762q.036-.38.036-.765a8.231,8.231,0,0,0-.991-3.917.89.89,0,1,0-1.534.9,5.153,5.153,0,0,1,.665,1.976,6.613,6.613,0,0,1-.053,2.344v.022a6.485,6.485,0,0,1-.262.89A19.743,19.743,0,0,0,1.321,29.52a1.335,1.335,0,1,0,2.027,1.739,16.806,16.806,0,0,1,19.468-4.492.861.861,0,0,0,.361.155,17.213,17.213,0,0,1,1.65.86,19.547,19.547,0,0,0,16.192,1.792,1.335,1.335,0,0,0,.85-1.691Z"
          transform="translate(0)"
          fill="#f22f46"
        />
      </g>
    </svg>
  );
};

export const IconStaffTab = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.69"
      height="14.703"
      viewBox="0 0 15.69 14.703"
    >
      <g id="shop" transform="translate(-1.537 -3.5)">
        <path
          id="Path_11893"
          data-name="Path 11893"
          d="M10,36v5.873H20.767V36"
          transform="translate(-6.002 -24.17)"
          fill="none"
          stroke="#919191"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="1"
        />
        <path
          id="Path_11894"
          data-name="Path 11894"
          d="M16.709,8.4a2.2,2.2,0,0,1-2.189,1.958,2.251,2.251,0,0,1-1.713-.832,2.19,2.19,0,0,1-1.713.832A2.238,2.238,0,0,1,9.382,9.53a2.238,2.238,0,0,1-1.713.832A2.19,2.19,0,0,1,5.956,9.53a2.286,2.286,0,0,1-1.713.832A2.2,2.2,0,0,1,2.054,8.4L4.977,4h8.809Z"
          fill="none"
          stroke="#919191"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="1"
        />
        <path
          id="Path_11895"
          data-name="Path 11895"
          d="M26,47.915V44h2.936v3.915"
          transform="translate(-18.087 -30.212)"
          fill="none"
          stroke="#919191"
          strokeMiterlimit="10"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export const IconQuantity = (props: IProps) => {
  return (
    <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5 1.5H2.5C1.94772 1.5 1.5 1.94772 1.5 2.5V21.5C1.5 22.0523 1.94772 22.5 2.5 22.5H19.5C20.0523 22.5 20.5 22.0523 20.5 21.5V2.5C20.5 1.94772 20.0523 1.5 19.5 1.5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 7.5H17.5"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 11.5H17.5"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 16.5H9.5"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconGreater = (props: IProps) => {
  return (
    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.166524 11.5835C-0.0353233 11.3816 -0.0536731 11.0658 0.111475 10.8432L0.166524 10.7794L5.07069 5.875L0.166523 0.970573C-0.0353242 0.768726 -0.053674 0.452868 0.111474 0.230292L0.166523 0.166525C0.36837 -0.0353222 0.684228 -0.0536719 0.906805 0.111476L0.970572 0.166525L6.27702 5.47298C6.47887 5.67482 6.49722 5.99068 6.33207 6.21326L6.27702 6.27702L0.970573 11.5835C0.748541 11.8055 0.388556 11.8055 0.166524 11.5835Z"
        fill="#919191"
      />
    </svg>
  );
};

export const IconAddToBasket = (props: IProps) => {
  return (
    <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.85228 18.7837C6.16665 18.7837 6.42043 19.0375 6.42043 19.3518C6.42043 19.6662 6.16665 19.921 5.85228 19.921C5.53687 19.921 5.28308 19.6662 5.28308 19.3518C5.28308 19.0375 5.53687 18.7837 5.85228 18.7837Z"
        fill="white"
      />
      <mask id="mask0_1882_80717" maskUnits="userSpaceOnUse" x="5" y="18" width="2" height="2">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.28259 19.3515C5.28259 19.6669 5.53638 19.9217 5.85284 19.9217C6.1672 19.9217 6.42099 19.6669 6.42099 19.3515C6.42099 19.0371 6.1672 18.7833 5.85284 18.7833C5.53638 18.7833 5.28259 19.0371 5.28259 19.3515Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1882_80717)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.0615234 25.1426H11.6429V13.5612H0.0615234V25.1426Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.85132 19.1376C5.7333 19.1376 5.63721 19.2337 5.63721 19.3517C5.63721 19.5888 6.06646 19.5888 6.06646 19.3517C6.06646 19.2337 5.96933 19.1376 5.85132 19.1376ZM5.85121 20.7043C5.10551 20.7043 4.49976 20.0975 4.49976 19.3518C4.49976 18.6061 5.10551 18.0003 5.85121 18.0003C6.59691 18.0003 7.20371 18.6061 7.20371 19.3518C7.20371 20.0975 6.59691 20.7043 5.85121 20.7043Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6334 18.7837C17.9478 18.7837 18.2026 19.0375 18.2026 19.3518C18.2026 19.6662 17.9478 19.921 17.6334 19.921C17.318 19.921 17.0642 19.6662 17.0642 19.3518C17.0642 19.0375 17.318 18.7837 17.6334 18.7837Z"
        fill="white"
      />
      <mask id="mask1_1882_80717" maskUnits="userSpaceOnUse" x="17" y="18" width="2" height="2">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.0645 19.3515C17.0645 19.6669 17.3182 19.9217 17.6337 19.9217C17.947 19.9217 18.2029 19.6669 18.2029 19.3515C18.2029 19.0371 17.947 18.7833 17.6337 18.7833C17.3182 18.7833 17.0645 19.0371 17.0645 19.3515Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_1882_80717)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8424 25.1426H23.4248V13.5612H11.8424V25.1426Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6325 19.1377C17.5155 19.1377 17.4194 19.2338 17.4194 19.3518C17.4205 19.5909 17.8487 19.5889 17.8476 19.3518C17.8476 19.2338 17.7505 19.1377 17.6325 19.1377ZM17.6323 20.7043C16.8866 20.7043 16.2809 20.0975 16.2809 19.3518C16.2809 18.6061 16.8866 18.0003 17.6323 18.0003C18.3791 18.0003 18.9859 18.6061 18.9859 19.3518C18.9859 20.0975 18.3791 20.7043 17.6323 20.7043Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7615 10.6972C20.256 10.6369 20.7211 11.0434 20.6497 11.5365L20.3424 13.6604C20.1555 14.9638 19.0233 15.9466 17.7074 15.9466H17.7022H6.30988H6.30153C4.92606 15.9466 3.76155 14.8729 3.6498 13.4995L2.69314 2.12184L1.11923 1.85029C0.692071 1.7751 0.406951 1.37091 0.480059 0.943752C0.555255 0.516593 0.967792 0.238782 1.38555 0.305624L3.5579 0.681608C3.90777 0.743227 4.17409 1.03357 4.20438 1.38867L4.44981 4.31403C7.94483 4.3155 10.6232 4.31703 12.6767 4.31861C13.0377 4.31889 13.3148 4.63453 13.3148 4.99552C13.3148 5.46626 12.9582 5.88782 12.4875 5.88739C11.8423 5.88681 11.1795 5.88619 10.5129 5.88557C8.43481 5.88362 6.31915 5.88164 4.58141 5.88063L5.21118 13.3711C5.25713 13.9476 5.72815 14.38 6.30362 14.38H6.30779H17.7032H17.7053C18.2494 14.38 18.7142 13.9747 18.7915 13.4369L19.1004 11.3043C19.1476 10.9778 19.434 10.7371 19.7615 10.6972Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0416 9.68365C21.5213 9.68365 23.5315 7.67346 23.5315 5.19377C23.5315 2.71408 21.5213 0.703888 19.0416 0.703888C16.5619 0.703888 14.5518 2.71408 14.5518 5.19377C14.5518 7.67346 16.5619 9.68365 19.0416 9.68365ZM19.0416 2.94883C19.3516 2.94883 19.6029 3.2001 19.6029 3.51006V4.63254H20.7253C21.0353 4.63254 21.2866 4.88381 21.2866 5.19377C21.2866 5.50373 21.0353 5.75501 20.7253 5.75501H19.6029V6.87748C19.6029 7.18744 19.3516 7.43871 19.0416 7.43871C18.7317 7.43871 18.4804 7.18744 18.4804 6.87748V5.75501H17.3579C17.048 5.75501 16.7967 5.50373 16.7967 5.19377C16.7967 4.88381 17.048 4.63254 17.3579 4.63254H18.4804V3.51006C18.4804 3.2001 18.7317 2.94883 19.0416 2.94883Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9837 10.7855H12.0886C11.6552 10.7855 11.3053 10.4346 11.3053 10.0022C11.3053 9.56979 11.6552 9.21887 12.0886 9.21887H14.9837C15.4161 9.21887 15.767 9.56979 15.767 10.0022C15.767 10.4346 15.4161 10.7855 14.9837 10.7855Z"
        fill="white"
      />
    </svg>
  );
};

export const IconMinus = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
      <g id="Group_3344" data-name="Group 3344" transform="translate(-316 -631)">
        <g id="Group_3343" data-name="Group 3343" transform="translate(-54 -291)">
          <g
            id="Ellipse"
            transform="translate(370 922)"
            fill="none"
            stroke="#a5a5a5"
            strokeWidth="1"
          >
            <circle cx="11" cy="11" r="11" stroke="none" />
            <circle cx="11" cy="11" r="10.5" fill="none" />
          </g>
          <g id="add" transform="translate(374 926)">
            <rect id="Boundary" width="15" height="15" fill="none" />
          </g>
        </g>
        <line
          id="Line_352"
          data-name="Line 352"
          x2="7"
          transform="translate(323.5 642.5)"
          fill="none"
          stroke="#a5a5a5"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export const IconPlus = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
      <g id="Group_3438" data-name="Group 3438" transform="translate(-59 -1)">
        <g id="Group_3342" data-name="Group 3342" transform="translate(-311 -921)">
          <g id="Ellipse" transform="translate(370 922)" fill="none" stroke="#000" strokeWidth="1">
            <circle cx="11" cy="11" r="11" stroke="none" />
            <circle cx="11" cy="11" r="10.5" fill="none" />
          </g>
        </g>
        <g id="e-add" transform="translate(65 7)">
          <line
            id="Line_364"
            data-name="Line 364"
            y2="8"
            transform="translate(5 1)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <line
            id="Line_365"
            data-name="Line 365"
            x2="8"
            transform="translate(1 5)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </svg>
  );
};

export const IconPosition = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21.538" height="22" viewBox="0 0 21.538 22">
      <g id="account" transform="translate(0.373 0.5)">
        <path
          id="Path_11584"
          data-name="Path 11584"
          d="M12.591,5.045c0,2.511-2.035,6.364-4.545,6.364S3.5,7.556,3.5,5.045a4.545,4.545,0,0,1,9.091,0Z"
          transform="translate(2.351 0)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_11585"
          data-name="Path 11585"
          d="M3.536,7A10,10,0,0,0,.627,12.149a17.251,17.251,0,0,0,19.538,0A10,10,0,0,0,17.256,7"
          transform="translate(0 5.318)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export const IconVariant = (props: IProps) => {
  return (
    <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 7.2001V13.0909" stroke="black" strokeWidth="1.8" />
      <circle cx="11.9994" cy="3.84" r="2.94" stroke="black" strokeWidth="1.8" />
      <circle cx="3.36" cy="15.8399" r="2.46" stroke="black" strokeWidth="1.8" />
      <circle cx="12.0005" cy="15.8399" r="2.46" stroke="black" strokeWidth="1.8" />
      <circle cx="20.6398" cy="15.8399" r="2.46" stroke="black" strokeWidth="1.8" />
      <path
        d="M3.3595 13.0909V12.5998C3.3595 10.9429 4.70264 9.59978 6.3595 9.59978H17.6395C19.2964 9.59978 20.6395 10.9429 20.6395 12.5998V13.0909"
        stroke="black"
        strokeWidth="1.8"
      />
    </svg>
  );
};

export const IconTime = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
      <g id="clock" transform="translate(-0.5 -0.945)">
        <circle
          id="Ellipse_107"
          data-name="Ellipse 107"
          cx="13"
          cy="13"
          r="13"
          transform="translate(1.5 1.945)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          id="Path_11583"
          data-name="Path 11583"
          d="M8.5,4.5v7.538h7.538"
          transform="translate(6.191 2.717)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};
export const PinDetailsIcon = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.279"
      height="17.744"
      viewBox="0 0 13.279 17.744"
    >
      <g transform="translate(-2)">
        <path
          d="M8.639,0a6.647,6.647,0,0,1,6.639,6.639c0,2.195-1.067,4.714-3.171,7.488a28.126,28.126,0,0,1-3.132,3.486.5.5,0,0,1-.673,0,28.126,28.126,0,0,1-3.132-3.486C3.067,11.353,2,8.834,2,6.639A6.647,6.647,0,0,1,8.639,0Zm0,16.552c1.262-1.239,5.639-5.834,5.639-9.912A5.639,5.639,0,1,0,3,6.639C3,10.722,7.377,15.313,8.639,16.552Z"
          fill="#a5a5a5"
        />
        <circle cx="2.5" cy="2.5" r="2.5" transform="translate(6.5 4.5)" fill="rgba(0,0,0,0)" />
        <path
          d="M2.5-.5a3,3,0,1,1-3,3A3,3,0,0,1,2.5-.5Zm0,5a2,2,0,1,0-2-2A2,2,0,0,0,2.5,4.5Z"
          transform="translate(6.5 4.5)"
          fill="#a5a5a5"
        />
      </g>
    </svg>
  );
};
export const PhoneStoreDetailsIcon = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <g transform="translate(0 0)">
        <path
          d="M13.769,16a1.482,1.482,0,0,1-.212-.015,15.87,15.87,0,0,1-4.944-1.544,15.889,15.889,0,0,1-4.094-2.961A15.889,15.889,0,0,1,1.559,7.387,15.868,15.868,0,0,1,.015,2.445,1.548,1.548,0,0,1,1.154.737L3.808.05A1.537,1.537,0,0,1,5.6.914L6.993,4.051a1.539,1.539,0,0,1-.445,1.825l-1.184.947a12.427,12.427,0,0,0,3.812,3.812l.947-1.184a1.54,1.54,0,0,1,1.825-.444L15.086,10.4a1.533,1.533,0,0,1,.864,1.793l-.688,2.651A1.544,1.544,0,0,1,13.769,16ZM4.195,1a.54.54,0,0,0-.136.017l-2.653.687a.546.546,0,0,0-.4.6,14.793,14.793,0,0,0,4.221,8.466,14.794,14.794,0,0,0,8.468,4.221.549.549,0,0,0,.074.005.544.544,0,0,0,.526-.407l.688-2.651a.536.536,0,0,0-.3-.627L11.543,9.922a.54.54,0,0,0-.639.155L9.682,11.6a.5.5,0,0,1-.644.119A13.421,13.421,0,0,1,4.277,6.961.5.5,0,0,1,4.4,6.318L5.924,5.1a.538.538,0,0,0,.155-.638L4.686,1.32A.538.538,0,0,0,4.195,1Z"
          fill="#a5a5a5"
        />
      </g>
    </svg>
  );
};
export const OpenningIcon = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
      <g transform="translate(-1 -1)">
        <path
          d="M7-.5A7.5,7.5,0,1,1-.5,7,7.508,7.508,0,0,1,7-.5Zm0,14A6.5,6.5,0,1,0,.5,7,6.507,6.507,0,0,0,7,13.5Z"
          transform="translate(1.5 1.5)"
          fill="#a5a5a5"
        />
        <path
          d="M12.5,9h-4A.5.5,0,0,1,8,8.5v-4a.5.5,0,0,1,1,0V8h3.5a.5.5,0,0,1,0,1Z"
          fill="#a5a5a5"
        />
      </g>
    </svg>
  );
};
